// The launch screen's tuning, from the PostHog flag `launch-loader`.

import { parseLoaderConfig, type LoaderConfig } from "./launch.ts";

export const LOADER_FLAG = "launch-loader";

export interface FlagReader {
	getFeatureFlagResult(
		key: string,
		options?: { send_event?: boolean },
	): { payload?: unknown } | undefined;
}

/**
 * The payload as posthog-js last stored it, read synchronously from its local
 * copy: a launch never waits on a flag request, and values fetched during this
 * launch apply on the next one. `send_event: false` because this read happens
 * on every launch and is not an exposure worth an event.
 */
export function readLoaderConfig(
	posthog: FlagReader | undefined | null,
	configured: boolean,
): LoaderConfig {
	if (!configured || !posthog) return parseLoaderConfig(undefined);
	try {
		return parseLoaderConfig(
			posthog.getFeatureFlagResult(LOADER_FLAG, { send_event: false })?.payload,
		);
	} catch {
		return parseLoaderConfig(undefined);
	}
}
